import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';
import { Globals } from '../globals';
@Component({
    selector: 'app-frontend',
    templateUrl: './frontend.component.html',
    styleUrls: ['./frontend.component.css'],
    animations: [
        trigger('heroState', [
            state('inactive', style({ transform: 'translateX(0) scale(1)' })),
            state('active', style({ transform: 'translateX(0) scale(1.1)' })),
            transition('inactive => active', animate('100ms ease-in')),
            transition('active => inactive', animate('100ms ease-out')),
            transition('void => inactive', [
                style({ transform: 'translateX(-100%) scale(1)' }),
                animate(100)
            ]),
            transition('inactive => void', [
                animate(100, style({ transform: 'translateX(100%) scale(1)' }))
            ]),
            transition('void => active', [
                style({ transform: 'translateX(0) scale(0)' }),
                animate(200)
            ]),
            transition('active => void', [
                animate(200, style({ transform: 'translateX(0) scale(0)' }))
            ])
        ])
    ]
})
export class FrontendComponent implements OnInit {
    public connect
    public token: any = {
        language: "api/language",
    }
    constructor(public translate: TranslateService, public router: Router, public globals: Globals) {
        //gọi file lang lên vsf đưa vào vi.json
        let lang = {};
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "language":
                    for (let key in res['data']) {
                        lang[key] = res['data'][key]['value'];
                        this.translate.set(key, res['data'][key]['value']);
                    }
                    break;
            }

        })

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                window.scroll(0, 0);
            }
        })
    }
    ngOnInit() {
        this.globals.send({ path: this.token.language, token: 'language' });
        if(window['scrolltop']){
            window['scrolltop']();
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/frontend/frontend.component.ts